import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import de from "@/features/promotions/locales/de";
import en from "@/features/promotions/locales/en";
import es from "@/features/promotions/locales/es";
import fr from "@/features/promotions/locales/fr";
import it from "@/features/promotions/locales/it";
import nl from "@/features/promotions/locales/nl";

export const promotionResources = { en, nl, de, fr, es, it };
export type PromotionCopyKey = keyof typeof en;
/** Versioned launch resources; existing Lokalise translations take precedence. */
export const usePromotionCopy = () => {
  const { locale = "en" } = useRouter();
  const { i18n, t } = useTranslation("promotions");
  const language =
    locale in promotionResources
      ? (locale as keyof typeof promotionResources)
      : "en";

  if (i18n?.addResourceBundle) {
    i18n.addResourceBundle(
      language,
      "promotions",
      promotionResources[language],
      true,
      false
    );
  }

  return {
    locale: language,
    copy: (key: PromotionCopyKey, values?: Record<string, string | number>) =>
      t(key, {
        lng: language,
        defaultValue: promotionResources[language][key],
        ...values,
      }),
  };
};
